// Angular:
import { Component, Input } from '@angular/core';

// Dependencies:
import { isNotNull, Value } from '@trademe/ensure';
import { StepIndicatorItemComponent } from '../step-indicator-item/step-indicator-item.component';

@Component({
    selector: 'tm-step-indicator-step-info',
    templateUrl: 'step-indicator-step-info.component.html'
})
export class StepIndicatorStepInfoComponent {
    @Input() @Value(isNotNull) public item: StepIndicatorItemComponent;
}
